var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileDocumentRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.876 66.8799L65.131 60.1666L71.876 53.4532L67.3794 48.9566L60.666 55.7016L53.9527 48.9566L49.456 53.4532L56.201 60.1666L49.456 66.8799L53.9527 71.3766L60.666 64.6316L67.3794 71.3766M19.4993 6.33325C15.9843 6.33325 13.166 9.18325 13.166 12.6666V63.3332C13.166 66.8482 15.9843 69.6666 19.4993 69.6666H44.231C43.091 67.7032 42.2993 65.5499 41.9193 63.3332H19.4993V12.6666H41.666V28.4999H57.4994V41.4199C58.5443 41.2616 59.621 41.1666 60.666 41.1666C61.7427 41.1666 62.7877 41.2616 63.8327 41.4199V25.3333L44.8327 6.33325M25.8327 37.9999V44.3333H51.166V37.9999M25.8327 50.6666V56.9999H41.666V50.6666H25.8327Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDocumentRemove);
export default __webpack_public_path__ + "static/media/file_document_remove.5330bf72f1e6f77a3a93b719716d5fd0.svg";
export { ForwardRef as ReactComponent };